import * as Yup from 'yup';

const requiredText = () => Yup.string().trim().required('Required');

export const motorValidationSchema = (lineCode: string) =>
  Yup.object({
    motorDetails: Yup.object({
      nameOnLicenseEN: requiredText(),
      nameOnLicenseAR: requiredText(),
      vignetteCode:
        lineCode === '50' ? requiredText() : Yup.string().trim().nullable(),
      vignette:
        lineCode === '50' ? requiredText() : Yup.string().trim().nullable(),
      plateCode: Yup.string().trim().notRequired(),
      plateNumber: Yup.string()
      .trim()
      .transform((value) => (value === '' ? undefined : value))
      .notRequired()
      .min(2, 'Plate Number should be between 2 and 300 digits')
      .max(300, 'Plate Number should be between 2 and 300 digits'),
      usage: requiredText(),
      body: requiredText(),
      engineType: requiredText(),
      make: requiredText(),
      model: requiredText(),
      yearOfMake: Yup.number()
        .typeError('Invalid Year of Make')
        .required('Required')
        .min(1900, 'Invalid Year of Make')
        .max(2100, 'Invalid Year of Make'),
      engine: requiredText(),
      weight: Yup.string()
        .trim()
        .when('body', {
          is: (body: string) => ['VAN', 'PICKUP', 'F_TANKER'].includes(body),
          then: (schema) =>
            schema
              .required('Required')
              .min(1, 'Invalid Weight')
              .max(2, 'Invalid Weight'),
          otherwise: (schema) => schema.notRequired()
        }),
      engineSize: Yup.string()
        .trim()
        .when('body', {
          is: 'MOTORCYCLE',
          then: (schema) =>
            schema
              .required('Required')
              .min(1, 'Invalid Engine Size')
              .max(2, 'Invalid Engine Size'),
          otherwise: (schema) => schema.notRequired()
        }),
      seatingCapacity: Yup.string()
        .trim()
        .required('Required')
        .min(1, 'Invalid Seats')
        .max(2, 'Invalid Seats'),
      chassis: requiredText()
        .min(2, 'Invalid Chassis')
        .max(50, 'Invalid Chassis'),
      horsePower: requiredText(),
      carValue:
        lineCode === '51' ? requiredText() : Yup.string().trim().nullable()
    })
  });
